// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__KdgLP","col":"styles_col__1H8zT"};